<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12" md="6">
        <v-card :loading="loading" class="my-6">
          <template slot="progress">
            <v-progress-linear height="10" indeterminate></v-progress-linear>
          </template>
          <template>
            <v-card-title>{{ patient_info.patient_id }}</v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Patient Name</td>
                    <td>{{ patient_info.patient_name }}</td>
                  </tr>

                  <tr>
                    <td>DOB</td>
                    <td>{{ patient_info.patient_dob }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ patient_info.patient_phone }}</td>
                  </tr>
                  <tr>
                    <td>Bloog Group</td>
                    <td>{{ patient_info.patient_blood_group }}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{ patient_info.patient_email }}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{{ patient_info.patient_address }}</td>
                  </tr>
                  <tr>
                    <td>Registration Date</td>
                    <td>{{ patient_info.admission_date }}</td>
                  </tr>
                  <tr>
                    <td>Referral</td>
                    <td>{{ referral_info.corporate_client.ps_name }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-col cols="12">
            <v-btn color="blue" label link outlined pill v-on:click="editItem(patient_info)"
              >Edit Patient Data</v-btn
            ><br/>
            <v-btn color="blue" label link outlined pill small disabled v-on:click="visionTherapy(patient_info)"
              >Vision Therapy</v-btn
            >
            <br/>
            <v-chip color="blue" label link outlined pill disabled>Medical Board</v-chip>
            <br/>
            <v-chip color="blue" label link outlined pill v-on:click="get_appointment(patient_info)"
              >Set Appointment</v-chip
            ><br/>
            <v-chip color="blue" label link outlined pill v-on:click="get_ot_schedule(patient_info)"
              >Set OT Schedule</v-chip
            ><br/>
            <v-btn color="blue" label link outlined pill v-on:click="create_invoice(patient_info)">Create Invoice</v-btn>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-card>
      <v-card-title>
        Service List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:item.invoice_description="{ item }">
          <span v-html="item.invoice_description"></span>
        </template>

        <template>
          <div>
            <v-icon small class="mr-2">mdi-pencil</v-icon>
            <v-icon small>mdi-delete</v-icon>
          </div>
        </template>
      </v-data-table>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-card>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      patient_id: this.$route.params.id,
      search: "",
      dialog: false,
      loading: true,
      desserts: [],
      headers: [
        { text: "InvoiceID", value: "invoice_id" },
        { text: "Invoice Type", value: "invoice_type" },

        { text: "Service Name", value: "invoice_description" },
        { text: "Eye", value: "invoice_eye_type" },
        { text: "Service Amount", value: "invoice_amount" },
        { text: "Date", value: "inv_date" },

        { text: "Action", value: "actions", sortable: false },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      errors: "",
      patient_info: {
        name: "",
      },
      referral_info: {
        corporate_client: {
          ps_name: "-",
        },
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: false,
          href: "/patients",
        },
        {
          text: "Patient Details",
          disabled: true,
          href: "patient-details",
        },
      ],
    };
  },

  // Fetches posts when the component is created.

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      atshq
        .get("patients/patient-profile/" + this.patient_id)
        .then((response) => {
          this.loading = false;
          // JSON responses are automatically parsed.

          this.patient_info = response.data.data.patient;
          this.referral_info = response.data.data.patient;
          this.desserts = response.data.data.invoice;
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log(e);
        });
    },
    editItem(item) {
       window.location.href = "/patient-create/" + item.patient_id;
    },
    visionTherapy(item) {
       window.location.href = "/services/vision-therapy/" + item.patient_id;
    },
    get_appointment(item) {
      window.location.href = "/appointment/create/" + item.patient_id;
      // window.open(this.returnUrl + "appointment/set/" + item.patient_id);
    },
    get_ot_schedule(item) {
      window.open(
        this.returnUrl +
          "cot/otSchedule?action=add&patient_id=" +
          item.patient_id
      );
    },
    create_invoice(item) {
      // window.location.href = "invoice-create/" + item.patient_id;
      window.open(
        this.returnUrl + "front_desk/invoice?patient_id=" + item.patient_id
      );
    },
  },
};
</script>